import React from 'react';
import PropTypes from 'prop-types';

import SlideButton from 'src/components/SlideBtn';
import SlideButtonImage from 'src/components/SlideBtnImg';
import 'src/components/SlideContent.scss';


/* eslint react/no-danger: 0 */
const SlideContentSubtitle = ({ subtitle }) => (
  <p
    dangerouslySetInnerHTML={ { __html: subtitle } }
    styleName="slide-subtitle"
  />
);

const SlideContent = ({
  title,
  offerCounter,
  isCounterOverButton,
  subtitle,
  buttons
}) => (
  <>
    <h3
      dangerouslySetInnerHTML={ { __html: title } }
      styleName="slide-title"
    />
    {
      !!subtitle
      && (
        <SlideContentSubtitle subtitle={ subtitle } />
      )
    }
    {!!isCounterOverButton && <SlideContentSubtitle subtitle={ offerCounter } />}
    {
      buttons.map(({
        img, text, altText, lightBgColor, translucentBorder, url, linkTitle
      }) => (
        img.length > 0
          ? (
            <SlideButtonImage
              key={ url }
              altText={ altText }
              img={ img }
              linkTitle={ linkTitle }
              url={ url }
            />
          )
          : (
            <SlideButton
              key={ url }
              lightBgColor={ lightBgColor }
              linkTitle={ linkTitle }
              smallerBtns={ buttons.length > 1 }
              text={ text }
              translucentBorder={ translucentBorder }
              url={ url }
            />
          )
      ))
    }
    {!isCounterOverButton && !!offerCounter && <SlideContentSubtitle subtitle={ offerCounter } />}
  </>
);

SlideContent.propTypes = {
  buttons: PropTypes.arrayOf(Object).isRequired,
  isCounterOverButton: PropTypes.bool.isRequired,
  offerCounter: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

SlideContentSubtitle.propTypes = {
  subtitle: PropTypes.string.isRequired
};

export default SlideContent;
